import { graphql } from "@/graphql/generated/gql";

export const getPublicDashboardEmbedQueryDocument = graphql(/* GraphQL */ `
  query getPublicDashboardEmbed($input: GetPublicDashboardInput!) {
    publicDashboardEmbed(getPublicDashboardInput: $input) {
      ...PublicDashboardEmbedCore
      publishedVersion {
        ...PublicDashboardVersionEmbedWithSections
      }
    }
  }
`);

export const getPublicDefaultTemplateEmbedQueryDocument = graphql(/* GraphQL */ `
  query getPublicDefaultTemplateEmbed($input: GetDefaultTemplateDashboardInput!) {
    publicDefaultTemplateEmbed(input: $input) {
      ...PublicDashboardEmbedCore
      publishedVersion {
        ...PublicDashboardVersionEmbedWithSections
      }
    }
  }
`);

export const getPublicIndicatorForDashboardQueryDocument = graphql(/* GraphQL */ `
  query GetPublicIndicatorForDashboard($input: GetPublicIndicatorForDashboardInput!) {
    publicIndicatorForDashboard(input: $input) {
      id
      workspaceId
      title
      description
      frequency
      unitId
      createdAt
      updatedAt
      unit: publicUnit {
        symbol
      }
      dataLineList {
        id
        indicatorId
        name
        color
        lineStyle
        isDefault
        order
      }
    }
  }
`);

export const getPublicIndicatorValuesForDashboardQueryDocument = graphql(/* GraphQL */ `
  query GetPublicIndicatorValuesForDashboard($input: GetPublicIndicatorForDashboardInput!) {
    publicIndicatorValuesForDashboard(input: $input) {
      id
      indicatorId
      dataLineId
      value
      date
      comment
      createdAt
      updatedAt
    }
  }
`);

export const getPublicClimateActionListForDashboardQueryDocument = graphql(/* GraphQL */ `
  query GetPublicClimateActionListForDashboard($input: GetPublicClimateActionListForDashboardInput!) {
    publicClimateActionListForDashboard(input: $input) {
      id
      title
      properties
      description
      workspaceId
      startDate
      endDate
      yearlyCosts
      reductionImpact
      createdAt
      updatedAt
      reductionCalculatorType {
        id
        name
      }
      publicAssigneeList {
        ...PublicAssigneeFields
      }
      priorityInstance {
        ...PublicPriorityInstanceFields
      }
      phaseInstance {
        ...PublicPhaseInstanceFields
      }
      labelInstanceList {
        ...PublicLabelInstanceFields
      }
      focusAreaInstance {
        ...PublicFocusAreaInstanceFields
      }
      teamInstanceList {
        ...PublicTeamInstanceFields
      }
      projectInstanceList {
        ...PublicProjectInstanceFields
      }
      statusInstance {
        ...PublicStatusInstanceFields
      }
      progressPercent
      taskList {
        id
        completed
      }
      milestoneList {
        id
        title
        dueDate
        order
        status
        taskList {
          id
          completed
        }
      }
    }
  }
`);

export const getPublicIndicatorListForEntityQueryDocument = graphql(/* GraphQL */ `
  query GetPublicIndicatorListForEntity($input: GetPublicIndicatorsForEntityInput!) {
    publicIndicatorListForEntity(input: $input) {
      id
      workspaceId
      title
      description
      frequency
      unitId
      createdAt
      updatedAt
      dataLineList {
        id
        indicatorId
        name
        color
        lineStyle
        isDefault
        order
      }
    }
  }
`);

export const getPublicFocusAreaListForDashboardQueryDocument = graphql(/* GraphQL */ `
  query GetPublicFocusAreaListForDashboard($input: GetPublicFocusAreaListForDashboardInput!) {
    publicFocusAreaListForDashboard(input: $input) {
      ...PublicFocusAreaFields
    }
  }
`);

export const getPublicPhaseListForDashboardQueryDocument = graphql(/* GraphQL */ `
  query GetPublicPhaseListForDashboard($input: GetPublicPhaseListForDashboardInput!) {
    publicPhaseListForDashboard(input: $input) {
      ...PublicPhaseFields
    }
  }
`);

export const getPublicPriorityListForDashboardQueryDocument = graphql(/* GraphQL */ `
  query GetPublicPriorityListForDashboard($input: GetPublicPriorityListForDashboardInput!) {
    publicPriorityListForDashboard(input: $input) {
      ...PublicPriorityFields
    }
  }
`);

export const getPublicLabelListForDashboardQueryDocument = graphql(/* GraphQL */ `
  query GetPublicLabelListForDashboard($input: GetPublicLabelListForDashboardInput!) {
    publicLabelListForDashboard(input: $input) {
      ...PublicLabelFields
    }
  }
`);

export const getPublicLabelGroupListForDashboardQueryDocument = graphql(/* GraphQL */ `
  query GetPublicLabelGroupListForDashboard($input: GetPublicLabelGroupListForDashboardInput!) {
    publicLabelGroupListForDashboard(input: $input) {
      id
      title
      color
      allowMultiSelect
      workspaceId
      labelList {
        ...PublicLabelFields
      }
    }
  }
`);

export const getPublicTeamListForDashboardQueryDocument = graphql(/* GraphQL */ `
  query GetPublicTeamListForDashboard($input: GetPublicTeamListForDashboardInput!) {
    publicTeamListForDashboard(input: $input) {
      ...PublicTeamFields
    }
  }
`);

export const getPublicInventoryListForDashboardQueryDocument = graphql(/* GraphQL */ `
  query GetPublicInventoryListForDashboard($input: GetPublicInventoryListForDashboardInput!) {
    publicInventoryListForDashboard(input: $input) {
      ...PublicInventoryWithSectorsFields
    }
  }
`);

export const getPublicInventoryListMinimalForDashboardQueryDocument = graphql(/* GraphQL */ `
  query GetPublicInventoryListMinimalForDashboard($input: GetPublicInventoryListMinimalForDashboardInput!) {
    publicInventoryListMinimalForDashboard(input: $input) {
      ...PublicInventoryBaseFields
      childInventoryList {
        id
        title
        year
        isMultiregion
        informational
        parentInventoryId
        rootInventoryId
      }
    }
  }
`);

export const getPublicInventoriesByIdsQueryDocument = graphql(/* GraphQL */ `
  query GetPublicInventoriesByIds($input: GetPublicInventoriesByIdsInput!) {
    publicInventoriesByIds(input: $input) {
      ...PublicInventoryWithSectorsFields
    }
  }
`);

export const getPublicProjectForDashboardQueryDocument = graphql(/* GraphQL */ `
  query GetPublicProjectForDashboard($input: GetPublicProjectForDashboardInput!) {
    publicProjectForDashboard(input: $input) {
      id
      workspaceId
      title
      description
      properties
      createdAt
      updatedAt
    }
  }
`);

export const getPublicProjectListForDashboardQueryDocument = graphql(/* GraphQL */ `
  query GetPublicProjectListForDashboard($input: GetPublicProjectListForDashboardInput!) {
    publicProjectListForDashboard(input: $input) {
      id
      title
      description
      properties
      workspaceId
      yearlyCosts
      createdAt
      updatedAt
      publicAssigneeList {
        ...PublicAssigneeFields
      }
      priorityInstance {
        ...PublicPriorityInstanceFields
      }
      phaseInstance {
        ...PublicPhaseInstanceFields
      }
      labelInstanceList {
        ...PublicLabelInstanceFields
      }
      focusAreaInstance {
        ...PublicFocusAreaInstanceFields
      }
      projectInstanceList {
        ...PublicProjectInstanceFields
      }
      statusInstance {
        ...PublicStatusInstanceFields
      }
      progressPercent
      milestoneList {
        id
        title
        dueDate
        order
        status
        taskList {
          id
          completed
        }
      }
    }
  }
`);

// Access is authorized via the x-dashboard-id header; input.dashboardId is required by the schema but is not the security boundary.
export const getPublicWorkspaceMembersForDashboardQueryDocument = graphql(/* GraphQL */ `
  query GetPublicWorkspaceMembers($input: GetPublicWorkspaceMembersForDashboardInput!) {
    getPublicWorkspaceMembers(input: $input) {
      id
      displayName
      avatarUrl
      teamIdList
    }
  }
`);

export const getPublicScenarioModelsForDashboardQueryDocument = graphql(/* GraphQL */ `
  query GetPublicScenarioModelsForDashboard($input: GetPublicScenarioModelsForDashboardInput!) {
    publicScenarioModelsForDashboard(input: $input) {
      id
      workspaceId
      title
      description
      startYear
      endYear
      createdAt
      updatedAt
      referenceInventory {
        id
        title
        year
        methodologyId
        informational
        sectorList {
          id
          title
          subsectorList {
            id
            title
            abbreviation
          }
        }
      }
      trendScenario {
        id
        title
        type
        targetYear
      }
      climateProtectionScenarioList {
        id
        title
        type
        targetYear
      }
    }
  }
`);

export const getPublicScenarioForDashboardQueryDocument = graphql(/* GraphQL */ `
  query GetPublicScenarioForDashboard($input: GetPublicScenarioForDashboardInput!) {
    publicScenarioForDashboard(input: $input) {
      id
      workspaceId
      scenarioModelId
      title
      description
      type
      targetYear
      displayConfig
      createdAt
      updatedAt
    }
  }
`);

export const getPublicScenarioInventoryListForDashboardQueryDocument = graphql(/* GraphQL */ `
  query GetPublicScenarioInventoryListForDashboard($input: GetPublicScenarioForDashboardInput!) {
    publicScenarioInventoryListForDashboard(input: $input) {
      id
      workspaceId
      scenarioModelId
      scenarioId
      methodologyId
      year
      totalEnergyConsumption
      totalEmissions
      energyValueList {
        id
        amount
        energySourceId
        sectorId
        subsectorId
        subsubsectorId
        type
      }
      emissionValueList {
        id
        amount
        energySourceId
        sectorId
        subsectorId
        subsubsectorId
        type
      }
      emissionFactorValueList {
        id
        amount
        energySourceId
        sectorId
        subsectorId
        subsubsectorId
        type
      }
      createdAt
      updatedAt
    }
  }
`);

export const getPublicEnergySourceListForDashboardQueryDocument = graphql(/* GraphQL */ `
  query GetPublicEnergySourceListForDashboard {
    publicEnergySourceListForDashboard {
      id
      title
    }
  }
`);
